import React, { useContext } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Swal from 'sweetalert2'
import JWTContext from '../../context/JWTContext';

const schema = yup.object({
    username: yup.string().required(),
    phoneNumber: yup.string().required(),
    email: yup.string().email().required(),
    password: yup.string().required().min(8, "Password too short")
      .test("isValidPass", "Password must be 8 char (one uppercase & one symbol & one number)", (value, context) => {
        const hasUpperCase = /[A-Z]/.test(value);
        const hasLowerCase = /[a-z]/.test(value);
        const hasNumber = /[0-9]/.test(value);
        const hasSymbole = /[!@#%&]/.test(value);
        let validConditions = 0;
        const numberOfMustBeValidConditions = 3;
        const conditions = [hasLowerCase, hasUpperCase, hasNumber, hasSymbole];
        conditions.forEach((condition) =>
          condition ? validConditions++ : null
        );
        if (validConditions >= numberOfMustBeValidConditions) {
          return true;
        }
        return false;
      }),
    confirmPassword: yup.string().required().oneOf([yup.ref('password')], 'Must match with "Password"'),
}).required();

const RegisterForm = ({ colors = {} }) => {
    const navigate = useNavigate();
    const [isShowPassword, setIsShowPassword] = React.useState(false);
    const [isShowConfirmPassword, setIsShowConfirmPassword] = React.useState(false);
    const [isCheckedAccept, setIsCheckedAccept] = React.useState(false);

    const location = useLocation();

    const params = new URLSearchParams(location.search);
    const redirectPath = params.get('redirect') || '/';

    const { register: registerAccount } = useContext(JWTContext);

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        if (isCheckedAccept) {
            //console.log('🟢 Form submitted:', data);
            try {
                const result = await registerAccount({
                    username: data.username,
                    phoneNumber: data.phoneNumber,
                    email: data.email,
                    password: data.password,
                    confirmPassword: data.confirmPassword
                });
                //console.log(result);
                Swal.fire({
                    title: "Success",
                    text: "Register successfully",
                    icon: "success"
                });
                navigate(`/login?redirect=${encodeURIComponent(redirectPath)}`);
            } catch (err) {
                //console.log(err);
                Swal.fire({
                    title: "Error",
                    text: err,
                    icon: "error"
                });
            }
        } else if (data.password !== data.confirmPassword) {
            Swal.fire({
                title: "Error",
                text: "Password and Confirm Password do not match.",
                icon: "error"
            });
        } else {
            Swal.fire({
                title: "Error",
                text: "Please accept the terms and conditions.",
                icon: "error"
            });
        }
    };

    return (
        <section className='d-flex position-relative align-items-center py-4 h-100' style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
            <div className='authFormRegister'>
                {/* <div className='d-flex justify-content-center mb-48'>
                    <a href="/">
                        <img
                            src='assets/images/logo/logo-pink-peony-white.png'
                            alt='Logo'
                            className="formLogo"
                        />
                    </a>
                </div> */}

                <style>
                    {`
                        .common-check .form-check-input.dynamic-checkbox:checked {
                            background-color: ${colors.categoryActive || '#2563EB'} !important;
                            border-color: ${colors.categoryActive || '#2563EB'} !important;
                        }
                    `}
                </style>
                <form onSubmit={handleSubmit(onSubmit)} className="border border-white-100 bg-white transition-1 rounded-16 px-24 py-40 h-100 shadow-lg">
                    <h6 className="text-3xl text-center mb-32" style={{ color: colors.categoryActive || '#2563EB' }}>Register</h6>
                    <div className='row mb-12'>
                        <div className="col-12 col-lg-6 mb-12">
                            <input
                                type="text"
                                className="common-input"
                                {...register('username')}
                                placeholder="Enter a Username"
                            />
                            {errors.username && <span className="text-danger text-sm text-capitalize">{errors.username.message}</span>}
                        </div>
                        <div className="col-12 col-lg-6 mb-12">
                            <input
                                type="email"
                                className="common-input"
                                {...register('email')}
                                placeholder="Enter Email Address"
                            />
                            {errors.email && <span className="text-danger text-sm text-capitalize">{errors.email.message}</span>}
                        </div>
                    </div>
                    <div className='row mb-12'>
                        {/* <div className="col-12 col-lg-6 mb-12">
                            <input
                                type="text"
                                className="common-input"
                                id="homenumber"
                                placeholder="Enter a Home Number"
                            />
                        </div> */}
                        <div className="col-12 col-lg-12 mb-12">
                            <input
                                type="text"
                                className="common-input"
                                {...register('phoneNumber')}
                                placeholder="Enter a Phone Number"
                            />
                            {errors.phoneNumber && <span className="text-danger text-sm text-capitalize">{errors.phoneNumber.message}</span>}
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-12 col-lg-6 mb-12">
                            <div className="position-relative">
                                <input
                                    type={isShowPassword ? 'text' : 'password'}
                                    className="inputPassword"
                                    {...register('password')}
                                    placeholder="Enter Password"
                                //defaultValue="password"
                                />
                                <span
                                    className={`toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ${isShowPassword ? 'ph-eye' : 'ph-eye-slash'}`}
                                    onClick={() => setIsShowPassword(!isShowPassword)}
                                />
                            </div>
                            {errors.password && <span className="text-danger text-sm text-capitalize">{errors.password.message}</span>}
                        </div>
                        <div className="col-12 col-lg-6 mb-12">
                            <div className="position-relative">
                                <input
                                    type={isShowConfirmPassword ? 'text' : 'password'}
                                    className="inputPassword"
                                    {...register('confirmPassword')}
                                    placeholder="Enter Confirm Password"
                                // defaultValue="password"
                                />
                                <span
                                    className={`toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ${isShowConfirmPassword ? 'ph-eye' : 'ph-eye-slash'}`}
                                    onClick={() => setIsShowConfirmPassword(!isShowConfirmPassword)}
                                />
                            </div>
                            {errors.confirmPassword && <span className="text-danger text-sm text-capitalize">{errors.confirmPassword.message}</span>}
                        </div>
                    </div>
                    <div className="mb-24">
                        <div className="form-check common-check">
                            <input
                                className="form-check-input dynamic-checkbox"
                                type="checkbox"
                                defaultValue={isCheckedAccept}
                                onChange={() => setIsCheckedAccept(!isCheckedAccept)}
                                id="remember"
                            />
                            <label
                                className="form-check-label flex-grow-1"
                                htmlFor="remember"
                                style={{ fontSize: '12px' }}
                            >
                                I agree with
                                <Link to="/term-and-condition" className="ms-5 text-decoration-underline" style={{ color: colors.categoryActive || '#2563EB' }}>
                                    terms & conditions
                                </Link>
                            </label>
                        </div>
                    </div>
                    <div className="mt-48">
                        <div className="flex-align gap-48 flex-wrap mb-24">
                            <button type="submit" className="btn w-100 rounded-pill py-15 px-40 text-white" style={{ backgroundColor: colors.categoryActive || '#2563EB', border: 'none' }}>
                                Register
                            </button>
                        </div>
                        {/* <div className="flex-align gap-48 flex-wrap mb-20">
                            <h4 className='text-center w-100 text-sm fw-medium'>or continue with</h4>
                        </div>
                        <div className="flex-align gap-48 flex-wrap mb-24">
                            <button type="submit" className="btn btn-white border border-main-one-600 hover-border-main-one-600 w-100 rounded-pill py-12 px-40">
                                <img
                                    src='assets/images/social/google.png'
                                    alt='Logo'
                                    className="w-20 h-20"
                                />
                            </button>
                        </div> */}
                        <div className="flex-align flex-wrap">
                            <h4 className='text-center w-100 text-sm fw-medium'>Already have an account? <Link to={`/login?redirect=${encodeURIComponent(redirectPath)}`} style={{ color: colors.categoryActive || '#2563EB', fontWeight: 'bold', textDecoration: 'none' }}>Login</Link></h4>
                        </div>
                    </div>

                </form>
            </div>
        </section>
    )
}

export default RegisterForm